import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import { CancelIconDialog } from '../Icons/Icon';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const useStyles = makeStyles((theme) => ({
    marginBottom20: {
        marginBottom: 20,
    },
    paper: {
        overflowY: 'unset',
    },
    hasScroll: {
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
    },
    textCenter: {
        textAlign: 'center',
    },
    img: {
        height: 'auto',
        maxWidth: '100%',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(-6),
        top: theme.spacing(-2),
        [theme.breakpoints.down('xs')]: {
            right: theme.spacing(-2),
            top: theme.spacing(-6),
        },
    },

}));
export default function ImgDialog(props) {
    const {
        handleClose,
        open,
        href,
    } = props;
    const classes = useStyles();

    return (
        <div>
            <Dialog
                // maxWidth="lg"
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                className={classes.textCenter}
                onDoubleClick={handleClose}
                PaperProps={{
                    style: {
                        maxWidth: '85vw',
                        maxHeight: '85vh',
                    },
                }}
                classes={{ paper: classes.paper }}

            >
                <div className={classes.hasScroll}>
                    <img src={href} className={classes.img} alt="" />
                </div>

                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CancelIconDialog />
                </IconButton>
            </Dialog>
        </div>
    );
}

ImgDialog.defaultProps = {
    handleClose: {},
    open: false,
    href: '',
};

ImgDialog.propTypes = {
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    href: PropTypes.string,
};
